import React from 'react';

import FindCareLinks from '../components/find-care-links';

const FindCareLinkBlock = (props) => <FindCareLinks {...props} />;

export default FindCareLinkBlock;
